import React from 'react';

import { SxProps } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

interface PanelProps {
  children: React.ReactNode;
  color?: string;
  sx?: SxProps;
}

const Panel = ({ children, color = 'white', sx = [] }: PanelProps) => {
  return (
    <Paper
      elevation={1}
      sx={[
        {
          p: 2,
          bgcolor: color,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Paper>
  );
};

export default Panel;
